import React, { useContext } from 'react';
import { GlobalStateContext } from 'context/global-context';
import ReactModal from 'react-modal';
import theme from 'styles/theme';
import isMobileDevice from '../../../../utils/deviceDetector';
import { togglePhoneModal, isSentSmsToggle } from 'actions';
import {
  ModalTemplate,
  SendPhone
} from '..';
import { sendSmsToPhoneOnLoadEvent } from '../../../../services/analytics';

const SendToPhoneModal = () => {
  const { state: { isModalOpen, isSmsSent }, dispatch } = useContext(GlobalStateContext);

  const toggleModalWindow = () => {
    dispatch(togglePhoneModal());
    if (isSmsSent) dispatch(isSentSmsToggle()); // TODO
  };

  const onAfterOpen = () => {
    // eslint-disable-next-line no-undef
    const { NETWORK_ID } = window.CRD_GLOBAL;
    sendSmsToPhoneOnLoadEvent(NETWORK_ID);
  }

  return (
    <ReactModal
      isOpen={isModalOpen}
      onRequestClose={toggleModalWindow}
      onAfterOpen={onAfterOpen}
      style={{
        overlay: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor:  '#313131cc',
          zIndex: 2
        },
        content: {
          position: 'initial',
          padding: 'none',
          border: 'none',
          borderRadius: theme.radii[1],
          overflow: 'hidden'
        }
      }}
      role='dialog'
      
      aria={{
        labelledby:"SentToPhone",
        modal:"true"
      }}
    >
      <ModalTemplate
        label="Send to phone"
        onClose={toggleModalWindow}
        id="SentToPhone"
      >
        <SendPhone />
      </ModalTemplate>
    </ReactModal>
  );
};

export default SendToPhoneModal;
